import React, { useCallback } from 'react';

import { Box, Typography } from '@mui/material';
import AccordionCDS from '@sharedCR/coreDesignSystem/AccordionCDS';
import PropTypes from 'prop-types';

import { PART_GROUP_ARROW_SIZE } from '../../FormChangeHistory.constants';
import { FormChangeHistoryTestIds } from '../../FormChangeHistory.testIds';
import TemplatePartRow from '../TemplatePartRow';

import { partGroupAccordionStyles, partGroupStyles } from './PartGroupAccordion.styles';

/** One group of changed parts: its name and kind counts, opening to a row per part. */
const PartGroupAccordion = ({ group, isExpanded, onToggle }) => {
  const onChange = useCallback(
    (event, expanded) => onToggle(expanded ? group.group : null),
    [onToggle, group.group],
  );

  return (
    <Box data-testid={FormChangeHistoryTestIds.PART_GROUP} sx={partGroupStyles}>
      <AccordionCDS
        additionalSummaryContent={
          <Typography
            color="text.secondary"
            data-testid={FormChangeHistoryTestIds.PART_GROUP_SUMMARY}
            variant="regular12"
          >
            {group.summary}
          </Typography>
        }
        arrowSize={PART_GROUP_ARROW_SIZE}
        className=""
        customStyles={partGroupAccordionStyles}
        expanded={isExpanded}
        title={group.title}
        titleVariant="medium14"
        onChange={onChange}
      >
        {group.rows.map(row => (
          <TemplatePartRow key={row.id} row={row} />
        ))}
      </AccordionCDS>
    </Box>
  );
};

PartGroupAccordion.propTypes = {
  group: PropTypes.shape({
    group: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    summary: PropTypes.string.isRequired,
    rows: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.string.isRequired })).isRequired,
  }).isRequired,
  isExpanded: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
};

export default PartGroupAccordion;
